import { trpc } from '@/shared/api';
import { quoteThumbnailRefetchInterval } from '../model/thumbnail-polling';

interface MyQuoteDetailQueryOptions {
  readonly enabled?: boolean;
}

/** 내 견적 상세(quotes.getMine) — 요청 내용·디자인 사본·최신 발행본·반려 사유. */
export const useMyQuoteDetailQuery = (
  quoteRequestId: string,
  options: MyQuoteDetailQueryOptions = {},
) =>
  trpc.quotes.getMine.useQuery(
    { quoteRequestId },
    {
      enabled: options.enabled ?? true,
      // 남의 견적(FORBIDDEN)·없는 견적(NOT_FOUND)은 재시도해도 같다.
      retry: false,
      // 그림은 요청 뒤 worker 가 몇 초 늦게 그린다 — 생길 때까지 잠깐 다시 조회한다
      // (창이 뒤에 있거나 다시 조회가 실패하면 멈춤, 응답 수 상한).
      refetchInterval: (query) => {
        const detail = query.state.data;
        return detail
          ? quoteThumbnailRefetchInterval(
              [{ thumbnailUrl: detail.design.thumbnailUrl, createdAt: detail.createdAt }],
              Date.now(),
              query.state,
            )
          : false;
      },
    },
  );
